(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const SIZE_ORDER = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL'];
  const DEFAULT_COLORS = ['Nude', 'Coffee', 'Black', 'Cream White', 'Burgundy'];
  const CHEV = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 6l12 12M18 6L6 18"/></svg>';

  /* minuteur : compte jusqu'a la date reglee, disparait une fois passee */
  function initTimers() {
    $$('[data-timer]').forEach((box) => {
      const end = new Date(box.dataset.timer).getTime();
      if (!end) { box.style.display = 'none'; return; }
      const pad = (n) => String(n).padStart(2, '0');
      const tick = () => {
        const d = end - Date.now();
        if (d <= 0) { box.style.display = 'none'; return false; }
        const days = Math.floor(d / 864e5), h = Math.floor(d / 36e5) % 24, m = Math.floor(d / 6e4) % 60, s = Math.floor(d / 1e3) % 60;
        const parts = days > 0 ? [[days, 'days'], [h, 'hrs'], [m, 'min']] : [[h, 'hrs'], [m, 'min'], [s, 'sec']];
        box.innerHTML = parts.map(([v, l]) => `<span class="ve-tm__b"><b>${pad(v)}</b><small>${l}</small></span>`).join('');
        return true;
      };
      if (tick()) setInterval(tick, 1000);
    });
  }

  /* minuteur en une ligne : disparait une fois la date passee */
  function initTimeLines() {
    $$('[data-tline]').forEach((box) => {
      const end = new Date(box.dataset.tline).getTime();
      const out = $('b', box);
      if (!end || !out) { box.style.display = 'none'; return; }
      const pad = (n) => String(n).padStart(2, '0');
      const tick = () => {
        const d = end - Date.now();
        if (d <= 0) { box.style.display = 'none'; return false; }
        const days = Math.floor(d / 864e5), h = Math.floor(d / 36e5) % 24, m = Math.floor(d / 6e4) % 60, s = Math.floor(d / 1e3) % 60;
        out.textContent = `${days > 0 ? `${days}d ` : ''}${pad(h)}:${pad(m)}:${pad(s)}`;
        return true;
      };
      if (tick()) setInterval(tick, 1000);
    });
  }

  /* en-tete cache en descendant, visible en remontant */
  function initHeader() {
    const h = $('.ve-hdr');
    if (!h) return;
    let last = window.scrollY;
    const top = $('[data-top]');
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      h.classList.toggle('is-up', y > last && y > 250);
      last = y;
      if (top) top.classList.toggle('on', y > 1800);
    }, { passive: true });
    if (top) top.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
    const b = $('[data-burger]'), m = $('.ve-mnav');
    if (b && m) b.addEventListener('click', () => m.classList.toggle('on'));
  }

  function initCarousels() {
    $$('[data-car]').forEach((c) => {
      const t = $('[data-track]', c), p = $('[data-prev]', c), n = $('[data-next]', c);
      if (!t) return;
      const step = () => { const k = t.children[0]; return k ? k.getBoundingClientRect().width + 20 : 300; };
      const sync = () => {
        if (p) p.disabled = t.scrollLeft < 5;
        if (n) n.disabled = t.scrollLeft + t.clientWidth > t.scrollWidth - 5;
        const dots = $$('[data-dot]', c);
        if (dots.length) {
          const i = Math.round(t.scrollLeft / (t.clientWidth || 1));
          dots.forEach((d, k) => { d.style.background = k === i ? '#111' : '#bbb'; });
        }
      };
      if (p) p.addEventListener('click', () => t.scrollBy({ left: -step(), behavior: 'smooth' }));
      if (n) n.addEventListener('click', () => t.scrollBy({ left: step(), behavior: 'smooth' }));
      t.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }

  function initGallery() {
    const main = $('#ve-main');
    const list = $('[data-tl]');
    if (!main || !list) return;
    const ths = $$('.ve-th', list);
    let cur = 0;
    const show = (i) => {
      cur = (i + ths.length) % ths.length;
      ths.forEach((t, k) => t.classList.toggle('on', k === cur));
      main.removeAttribute('srcset'); main.src = ths[cur].dataset.src;
      main.alt = $('img', ths[cur]).alt;
      const badge = $('#ve-main-badge');
      if (badge) badge.style.display = cur === 0 ? '' : 'none';
      const t = ths[cur];
      list.scrollLeft = t.offsetLeft - list.offsetLeft - (list.clientWidth - t.clientWidth) / 2;
    };
    ths.forEach((t, i) => t.addEventListener('click', () => show(i)));
    const p = $('[data-tprev]'), n = $('[data-tnext]');
    if (p) p.addEventListener('click', () => show(cur - 1));
    if (n) n.addEventListener('click', () => show(cur + 1));
  }

  /* aide a la taille : soutien-gorge (tour + bonnet ou mesure), tour de taille, ou poids */
  function initSizeFinder() {
    const STEP = { A: 1, B: 2, C: 3, D: 4, DD: 5, E: 5, DDD: 6, F: 6, DDDD: 7, G: 7, H: 8, I: 9, J: 10, K: 11, L: 12, M: 13 };
    $$('[data-fs]').forEach((f) => {
      const mode = f.dataset.mode || 'bra';
      const rules = mode === 'weight' ? [] : (f.dataset.rules || '').split(',').map((x) => x.split(':')).filter((x) => x.length === 2).map(([s, n]) => [s.trim(), parseFloat(n)]);
      const a = $('[data-fs-a]', f), sz = $('[data-fs-s]', f), no = $('[data-fs-no]', f), res = $('[data-fs-r]', f);
      const show = (size) => {
        if (a) a.hidden = !size;
        if (sz) sz.textContent = size || '';
        if (no) no.hidden = !!size;
        if (res) res.hidden = false;
        if (size) document.dispatchEvent(new CustomEvent('ve:size', { detail: size }));
      };
      /* poitrine : la limite haute appartient a la taille suivante ; tour de taille : elle reste dans la taille */
      const byValue = (v) => {
        const r = rules.find(([, max]) => (mode === 'waist' ? v <= max : v < max));
        return r ? r[0] : '';
      };
      $$('.ve-fs__o', f).forEach((g) => {
        g.addEventListener('click', (e) => {
          const b = e.target.closest('button');
          if (!b) return;
          $$('button', g).forEach((x) => x.classList.remove('on'));
          b.classList.add('on');
          if (mode === 'weight') {
            show(b.dataset.size && b.dataset.size !== 'none' ? b.dataset.size : '');
            return;
          }
          const on = $$('.ve-fs__o .on', f);
          if (on.length === 2) show(byValue(parseInt(on[0].textContent, 10) + (STEP[on[1].textContent.trim()] || 0)));
        });
      });
      const go = $('[data-fs-go]', f);
      if (go) go.addEventListener('click', () => {
        const val = $('.ve-fs__m input', f).value;
        const n = parseFloat(val.replace(',', '.'));
        if (isNaN(n)) return;
        const cm = /cm/i.test(val) || n > (mode === 'waist' ? 60 : 70);
        show(byValue(cm ? n / 2.54 : n));
      });
    });
    $$('a[href="#ve-size"]').forEach((a) => a.addEventListener('click', () => { const d = $('#ve-size'); if (d) d.open = true; }));
  }

  /* offres : une ligne couleur + taille par piece, tout part au panier d'un coup */
  function initOffers() {
    const root = $('[data-offers]');
    if (!root || !window.veVariants) return;
    const variants = window.veVariants;
    const thumbs = window.veThumbs || {};
    const swatch = window.veSwatches || {};
    const colors = [...new Set(variants.map((v) => v.c))];
    const sizes = [...new Set(variants.map((v) => v.s))].sort((a, b) => SIZE_ORDER.indexOf(a) - SIZE_ORDER.indexOf(b));
    const find = (c, s) => variants.find((v) => v.c === c && v.s === s);
    const addToCart = async (btn, items) => {
      if (!items.length) return;
      btn.disabled = true;
      try {
        const r = await fetch(`${window.veRoot || '/'}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
        if (!r.ok) throw new Error(String(r.status));
        await openCart();
      } catch (e) {
        btn.textContent = root.dataset.err || 'Please try again';
      } finally {
        btn.disabled = false;
      }
    };

    /* onglets cote a cote : une ligne par piece, une taille pour toutes */
    if (root.dataset.layout === 'tabs') {
      const tabs = $$('.ve-tab', root);
      const box = $('[data-rows]', root), szBox = $('[data-sizes]', root), szL = $('[data-size-l]', root), szE = $('[data-size-e]', root);
      const piece = root.dataset.piece || 'Piece';
      let size = '';
      const paint = (row) => {
        const c = row.dataset.c, im = $('[data-i]', row);
        $('[data-n]', row).textContent = c;
        if (thumbs[c]) im.src = thumbs[c];
        $$('[data-col]', row).forEach((b) => b.classList.toggle('on', b.dataset.col === c));
      };
      const draw = (tab) => {
        const qty = +tab.dataset.qty, free = +tab.dataset.free || 0;
        const keep = $$('[data-row]', box).map((r) => r.dataset.c);
        let html = '';
        for (let i = 0; i < qty; i++) {
          html += `<div class="ve-pc" data-row data-c="${esc(keep[i] || colors[0])}"><img src="" alt="" width="64" height="64" data-i><div><div class="ve-pc__n">${i >= qty - free ? '<em>FREE</em> ' : ''}<b>${esc(piece)} ${i + 1}:</b> <span data-n></span></div><div class="ve-pc__d">${colors.map((x) => `<button class="ve-cd" type="button" data-col="${esc(x)}" style="background:${esc(swatch[x] || '#ddd')}" title="${esc(x)}" aria-label="${esc(x)}"></button>`).join('')}</div></div></div>`;
        }
        box.innerHTML = html;
        $$('[data-row]', box).forEach(paint);
        tabs.forEach((t) => t.classList.toggle('on', t === tab));
      };
      box.addEventListener('click', (e) => {
        const b = e.target.closest('[data-col]');
        if (!b) return;
        const r = b.closest('[data-row]');
        r.dataset.c = b.dataset.col;
        paint(r);
      });
      tabs.forEach((t) => t.addEventListener('click', () => draw(t)));
      draw($('.ve-tab.on', root) || tabs[0]);
      szBox.innerHTML = sizes.map((s) => `<button class="ve-sz" type="button" data-sz="${esc(s)}">${esc(s)}</button>`).join('');
      szBox.addEventListener('click', (e) => {
        const b = e.target.closest('[data-sz]');
        if (!b) return;
        size = b.dataset.sz;
        szL.textContent = size;
        szE.hidden = true;
        $$('[data-sz]', szBox).forEach((x) => x.classList.toggle('on', x === b));
      });
      document.addEventListener('ve:size', (e) => {
        const b = $$('[data-sz]', szBox).find((x) => x.dataset.sz === e.detail);
        if (b) b.click();
      });
      const btn = $('[data-atc]', root);
      btn.addEventListener('click', () => {
        if (!size) { szE.hidden = false; szBox.scrollIntoView({ block: 'center', behavior: 'smooth' }); return; }
        addToCart(btn, $$('[data-row]', box).map((r) => find(r.dataset.c, size)).filter((v) => v && v.a).map((v) => ({ id: v.id, quantity: 1 })));
      });
      return;
    }

    const useDefaults = DEFAULT_COLORS.every((x) => colors.includes(x));
    const sizeErr = $('[data-size-e]', root);
    /* la taille trouvee par l'aide remplit les lignes de l'offre */
    document.addEventListener('ve:size', (e) => {
      $$('[data-s]', root).forEach((o) => {
        if ([...o.options].some((x) => x.value === e.detail && !x.disabled)) {
          o.value = e.detail;
          o.closest('.ve-pill').classList.remove('is-err');
        }
      });
      if (sizeErr) sizeErr.hidden = true;
    });
    $$('.ve-of', root).forEach((of) => {
      const qty = +of.dataset.qty;
      const box = $('.ve-of__rows', of);
      let html = `<div class="ve-of__cs">${esc(root.dataset.colsize)}</div>`;
      for (let i = 0; i < qty; i++) {
        const c = useDefaults ? DEFAULT_COLORS[i] : colors[i % colors.length];
        html += `<div class="ve-row" data-row><span class="ve-row__n">#${i + 1}</span>`
          + `<label class="ve-pill"><span data-t></span><select data-c aria-label="Colour ${i + 1}">${colors.map((x) => `<option${x === c ? ' selected' : ''}>${esc(x)}</option>`).join('')}</select></label>`
          + `<label class="ve-pill"><select data-s aria-label="Size ${i + 1}"></select></label></div>`;
      }
      box.innerHTML = html;
      $$('[data-row]', box).forEach((row) => {
        const cs = $('[data-c]', row), ss = $('[data-s]', row), t = $('[data-t]', row);
        const paint = () => {
          const c = cs.value, keep = ss.value;
          const src = thumbs[c];
          t.innerHTML = src ? `<img src="${esc(src)}" alt="" width="34" height="34" loading="lazy">` : `<span class="ve-pill__d" style="display:block;background:${esc(swatch[c] || '#ddd')}"></span>`;
          ss.innerHTML = '<option value="">Size</option>' + sizes.map((s) => {
            const v = find(c, s);
            const out = !v || !v.a;
            return `<option value="${esc(s)}"${out ? ' disabled' : ''}>${esc(s)}${out ? ' - out of stock' : ''}</option>`;
          }).join('');
          const opt = [...ss.options].find((o) => o.value === keep && !o.disabled);
          ss.value = opt ? keep : '';
        };
        cs.addEventListener('change', paint);
        ss.addEventListener('change', () => {
          if (sizeErr) sizeErr.hidden = true;
          ss.closest('.ve-pill').classList.remove('is-err');
          if (!ss.value) return;
          /* la taille choisie remplit les lignes encore vides */
          $$('[data-s]', root).forEach((o) => {
            if (o.value) return;
            if ([...o.options].some((x) => x.value === ss.value && !x.disabled)) {
              o.value = ss.value;
              o.closest('.ve-pill').classList.remove('is-err');
            }
          });
        });
        paint();
      });
      const radio = $('input[type=radio]', of);
      radio.addEventListener('change', () => {
        $$('.ve-of', root).forEach((o) => o.classList.toggle('on', o === of));
      });
    });

    const atc = $('[data-atc]', root);
    if (atc) atc.addEventListener('click', () => {
      const of = $('.ve-of.on', root);
      const rows = $$('[data-row]', of);
      const empty = rows.filter((r) => !$('[data-s]', r).value);
      if (empty.length) {
        empty.forEach((r) => $('[data-s]', r).closest('.ve-pill').classList.add('is-err'));
        if (sizeErr) sizeErr.hidden = false;
        empty[0].scrollIntoView({ block: 'center', behavior: 'smooth' });
        return;
      }
      addToCart(atc, rows.map((r) => find($('[data-c]', r).value, $('[data-s]', r).value)).filter((v) => v && v.a).map((v) => ({ id: v.id, quantity: 1 })));
    });
  }

  /* tiroir panier */
  const dr = () => $('#ve-dr');
  /* meme ecriture des prix que sur les fiches : veMoney vient du filtre money (1234,56) */
  const fmt = (cents, cur) => {
    const m = String(window.veMoney || '').match(/^(\D*)1(\D?)234(\D)56(\D*)$/);
    if (!m) return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur }).format(cents / 100);
    const [whole, dec] = (cents / 100).toFixed(2).split('.');
    return m[1] + whole.replace(/\B(?=(\d{3})+$)/g, m[2]) + m[3] + dec + m[4];
  };
  const giftCode = () => { try { return sessionStorage.getItem('ve-gift') || ''; } catch (e) { return ''; } };
  function renderCart(cart) {
    const box = $('[data-dr-b]', dr());
    if (!box) return;
    $$('[data-bub]').forEach((b) => { b.textContent = cart.item_count; b.style.display = cart.item_count ? 'flex' : 'none'; });
    if (!cart.items.length) {
      box.innerHTML = `<div class="ve-dr__e"><h2>Your cart is empty</h2><a class="b" href="${esc(box.dataset.shop)}">Continue shopping</a><h3>Have an account?</h3><p><a href="${esc(box.dataset.login)}">Log in</a> to check out faster.</p></div>`;
      return;
    }
    box.innerHTML = `<div class="ve-dr__h">Your cart</div><div class="ve-dr__l">${cart.items.map((i, k) => `<div class="ve-ci"><a href="${esc(i.url)}"><img src="${esc(i.image || '')}" alt="" width="80" height="80" loading="lazy"></a><div><b>${esc(i.product_title)}</b>${esc(i.variant_title || '')}<div class="ve-q"><button type="button" data-q="${k + 1}" data-v="${i.quantity - 1}" aria-label="Remove one">−</button>${i.quantity}<button type="button" data-q="${k + 1}" data-v="${i.quantity + 1}" aria-label="Add one">+</button></div></div><div class="ve-ci__p">${i.final_line_price < i.original_line_price ? `<s>${esc(fmt(i.original_line_price, cart.currency))}</s>` : ''}${esc(fmt(i.final_line_price, cart.currency))}</div></div>`).join('')}</div><div class="ve-dr__f">${cart.total_discount > 0 ? `<div class="ve-dr__d"><span>You save</span><span>${esc(fmt(cart.total_discount, cart.currency))}</span></div>` : ''}<div class="ve-dr__s"><span>Subtotal</span><span>${esc(fmt(cart.total_price, cart.currency))}</span></div><div class="ve-dr__n">Taxes and shipping calculated at checkout.${giftCode() ? ` Your gift code ${esc(giftCode())} will be applied at checkout.` : ''}</div><form action="${esc(box.dataset.cartUrl)}" method="post"><button class="ve-dr__c" type="submit" name="checkout">CHECK OUT</button></form></div>`;
  }
  const root_ = () => window.veRoot || '/';
  async function refreshCart() {
    const r = await fetch(`${root_()}cart.js`, { headers: { Accept: 'application/json' } });
    if (r.ok) renderCart(await r.json());
  }
  async function openCart() {
    await refreshCart();
    dr().classList.add('on');
  }
  function initCart() {
    const d = dr();
    if (!d) return;
    $$('[data-cart]').forEach((a) => a.addEventListener('click', (e) => { e.preventDefault(); openCart(); }));
    d.addEventListener('click', async (e) => {
      if (e.target.closest('[data-dr-x]')) { d.classList.remove('on'); return; }
      const q = e.target.closest('[data-q]');
      if (q) {
        const r = await fetch(`${root_()}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: +q.dataset.q, quantity: +q.dataset.v }) });
        if (r.ok) renderCart(await r.json());
      }
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') d.classList.remove('on'); });
    refreshCart();
  }

  /* pop-up ticket a gratter */
  function initPopup() {
    const p = $('[data-pop]');
    if (!p) return;
    const force = /[?&]pop=1/.test(location.search);
    if (window.Shopify && Shopify.designMode && !force) return;
    let seen = false;
    try { seen = sessionStorage.getItem('ve-pop') === '1'; } catch (e) { /* navigation privee */ }
    if (seen && !force) return;
    const close = () => { p.classList.remove('on'); try { sessionStorage.setItem('ve-pop', '1'); } catch (e) { /* navigation privee */ } };
    $$('[data-pop-x]', p).forEach((b) => b.addEventListener('click', close));
    /* le lien /discount/CODE active le code ; on retient juste de ne plus ouvrir le pop-up */
    $$('[data-pop-use]', p).forEach((a) => a.addEventListener('click', () => {
      try { sessionStorage.setItem('ve-pop', '1'); sessionStorage.setItem('ve-gift', a.dataset.popUse); } catch (e) { /* navigation privee */ }
    }));
    setTimeout(() => {
      p.classList.add('on');
      const c = $('canvas', p);
      if (!c) return;
      const r = c.parentElement.getBoundingClientRect();
      c.width = r.width; c.height = r.height;
      const x = c.getContext('2d');
      x.fillStyle = '#42303c'; x.fillRect(0, 0, c.width, c.height);
      x.fillStyle = '#fff'; x.font = '700 15px Lato,sans-serif'; x.textAlign = 'center';
      x.fillText(c.dataset.label || 'Scratch here', c.width / 2, c.height / 2 + 5);
      x.globalCompositeOperation = 'destination-out';
      let down = false;
      const at = (e) => { const b = c.getBoundingClientRect(); x.beginPath(); x.arc(e.clientX - b.left, e.clientY - b.top, 20, 0, 7); x.fill(); };
      c.addEventListener('pointerdown', (e) => { down = true; at(e); });
      c.addEventListener('pointermove', (e) => { if (down) at(e); });
      window.addEventListener('pointerup', () => { down = false; });
    }, 3500);
  }

  const start = () => {
    window.veRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || window.veRoot || '/';
    initTimers(); initTimeLines(); initHeader(); initCarousels(); initGallery(); initSizeFinder(); initOffers(); initCart(); initPopup();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', () => { initTimers(); initTimeLines(); initCarousels(); initGallery(); initSizeFinder(); initOffers(); });
})();
